// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Gbv-","bigColWidth":"Table_bigColWidth__22eRB","biggerColWidth":"Table_biggerColWidth__KPR-f","row":"Table_row__11pbG","col":"Table_col__1Clu1"};